import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindReportGrid, exportToExcel, OpenBase64Pdf, setFocus, setTitle, GetDate, formatDate, ReverseFormatDate } from '../Common/Common';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import { useNavigate } from "react-router-dom";
import Loader from '../Layout/Loader';

const DailySaleReport = ({ open, setOpen }) => {
    const [isUpdate, setIsUpdate] = useState(false)
    const [MenuText, setMenuText] = useState("Daily Payment Register Report");
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const [CustomerData, setCustomerData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState({})
    const navigate = useNavigate();
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode')
    const WarehouseName = cookies.get('warehouseName');
    const WarehouseCode = cookies.get('warehouseCode');
    const [WareHouse, setWarehouseData] = useState([]);
    const [salesPerson, setSalesPerson] = useState([]);

    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        DateFrom: GetDate(0),
        DateTo: GetDate(0),
        WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
    });

    useEffect(() => {
        setTitle('DailySaleReport', setOpen);
        setFocus('txtSalesPerson');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                DateFrom: GetDate(0),
                DateTo: GetDate(0),
                WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
            }
        );
        setFocus('txtSalesPerson');
        setIsUpdate(!isUpdate)
    }

    const ClearData = () => {
        setFilterData(
            {
                WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
            }
        );
        setFocus('txtSalesPerson');
        setIsUpdate(!isUpdate)
    }

    const searchHandle = () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getDailySaleReport()
    }
    const handlePrintData = (ID,) => {
       
        const loginCodeString = String(LoginUserCode);
       
        const data = {
            ...FilterData,
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true);
        post(`${API_SERVER}/api/Print/DailyPaymentRegister`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                OpenBase64Pdf(res.documentPdfBase64, 'DailyPaymentRegister_' + ID, '_blank');
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
        })
        setIsLoading(false)
    }

    const handleDownloadExcel = async () => {
        getDailySaleReport('E');
    }

    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }
    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    let SalesPersonArr = []
    for (let i = 0; i < salesPerson.length; i++) {
        let mydata = salesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };
    const getWareHouse = (salesPerson) => {
        setWarehouseData([]);
        let temp = {
            Type: "GetWarehouse",
            Prefix: "",
            ContextKey: FilterData.SalesPerson ? FilterData.SalesPerson : salesPerson,
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let WareHouseData = res.autoCompleteData || [];
                setWarehouseData(WareHouseData);
            } else {
                console.error("Error fetching Ware house data:", res.message);
                setWarehouseData([]);
            }
        });
    };
    let WareHouseArr = []
    for (let i = 0; i < WareHouse.length; i++) {
        let mydata = WareHouse[i]?.values
        WareHouseArr.push(mydata)
    };
    const getDailySaleReport = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExShowDailySaleReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'Daily_Payment_Register_Report');
                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({});
            }
            setIsLoading(false)
        });
    }
    const handleChange1 = (event, value) => {
        getDailySaleReport('S', value);
    };

    //useEffect(() => {
    //    getDailySaleReport();
    //}, [FilterData.PageIndex, isUpdate])


    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtItem") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                required={true}
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    const salesPerson = newInputValue;
                                                    HandleChange('SalesPerson', newInputValue)
                                                    //ClearData();
                                                    getWareHouse(salesPerson);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                label='WareHouse / Sales Person'
                                                disabled={WarehouseCode ? true : false}
                                                placeholder="WareHouse / Sales Person"
                                                maxLength='50'
                                                options={WareHouseArr}
                                                id='txtWareHouse'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getWareHouse()}
                                                inputValue={FilterData.WareHouse ? FilterData.WareHouse : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('WareHouse', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Payment Date</label>
                                            <div className="row">
                                                <div className="col-3">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.DateFrom) || null}
                                                        id='txtDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, DateFrom: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtDateTo')
                                                            };
                                                        }}
                                                       
                                                        maxDate={new Date()}
                                                    /></div>
                                                {/*<div className="col-3">*/}
                                                {/*    <DatePicker*/}
                                                {/*        selected={ReverseFormatDate(FilterData.DateTo) || null}*/}
                                                {/*        id='txtDateTo'*/}
                                                {/*        className="form-control"*/}
                                                {/*        placeholderText='From Date'*/}
                                                {/*        dateFormat={'dd-MMM-yyyy'}*/}
                                                {/*        autoComplete='off'*/}
                                                {/*        onChange={(date) => {*/}
                                                {/*            setFilterData({ ...FilterData, DateTo: formatDate(date) })*/}
                                                {/*        }}*/}
                                                {/*        onKeyDown={(e) => {*/}
                                                {/*            if (e.key === 'Enter') {*/}
                                                {/*                setFocus('btnSearch')*/}
                                                {/*            };*/}
                                                {/*        }}*/}
                                                {/*        maxDate={new Date()}*/}
                                                {/*    />*/}
                                                {/*</div>*/}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button print-btn" onClick={handlePrintData} >
                                                <i className="bi bi-printer" /> Print
                                            </button>
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn">
                                                <i className="bi bi-arrow-clockwise" onClick={handleClearData} /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} handleChange1={handleChange1} currentPageNo={currentPageNo}
            />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default DailySaleReport